import { getterTypesSlideOuts } from '@/store/modules/slide-outs/types'

export default {
    [getterTypesSlideOuts.GET_SELECTED_SLIDE_OUT]: (state) =>
        state.selectedComponent,
    [getterTypesSlideOuts.GET_PROPS]: (state) => state.props,
}
